import { render, staticRenderFns } from "./AuthLayout2.vue?vue&type=template&id=b16e66e0&"
import script from "./AuthLayout2.vue?vue&type=script&lang=js&"
export * from "./AuthLayout2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports